module.exports = __webpack_public_path__ + "static/brand-hero_og-ffadbf6643f452c7c075b40e4079dded.png";